export const CallAnalyticsTab = {
  Overview: 'overview',
  VoiceAgent: 'voice-agent',
  CallQuality: 'call-quality',
} as const

export type CallAnalyticsTabValue =
  (typeof CallAnalyticsTab)[keyof typeof CallAnalyticsTab]

export const CALL_ANALYTICS_TAB_LABELS: Record<CallAnalyticsTabValue, string> =
  {
    [CallAnalyticsTab.Overview]: 'Overview',
    [CallAnalyticsTab.VoiceAgent]: 'Voice Agent',
    [CallAnalyticsTab.CallQuality]: 'Call Quality',
  }

const VALID_TAB_VALUES = new Set<string>(Object.values(CallAnalyticsTab))

// Older URL values map to current canonical names so saved links keep working
// when a tab is renamed.
const TAB_ALIASES: Record<string, CallAnalyticsTabValue> = {
  general: CallAnalyticsTab.Overview,
}

// Falls back to Overview for missing, unknown, or otherwise-invalid URL
// values so a typo or stale link never lands the user on a blank page.
export const resolveTabFromUrl = (
  raw: string | null
): CallAnalyticsTabValue => {
  if (!raw) return CallAnalyticsTab.Overview
  const aliased = TAB_ALIASES[raw] ?? raw
  return VALID_TAB_VALUES.has(aliased)
    ? (aliased as CallAnalyticsTabValue)
    : CallAnalyticsTab.Overview
}
